import React from "react";

import { Routes as Switch, Route } from "react-router-dom";
import { Routes } from "../util/routes";

// Error Views
import NotFoundPage from "./error/NotFound";

// No Auth Views
import ForgotPassword from "./no-auth/forgot-password";
import ContactSales from "./no-auth/contact-sales";
import LoginPage from "./no-auth/log-in";
import Home from "./no-auth/home";

// Resources
import Contact from "./no-auth/navbarPages/contact";
import Pricing from "../pages/no-auth/navbarPages/FullPricing";

// Legal
import TermsAndConditions from "./legal/TermsAndConditions";
import PrivacyPolicy from "./legal/PrivacyPolicy";

// About
import AboutUs from "./no-auth/navbarPages/AboutUs";
// import Partner from "./no-auth/navbarPages/Partner";

// Knowledge Bank
import KnowledgeBank from "./knowledge-bank";
import KnowledgeBankArticle from "./knowledge-bank/Article";

/** The Main Page Of The Application */
const Main = () => (
  <Switch>
    {/* No Auth */}
    <Route path={Routes.NotLoggedIn.path} element={<Home />} />
    <Route path={Routes.Signin.path} element={<LoginPage />} />
    <Route path={Routes.Contact.path} element={<Contact />} />
    <Route path={Routes.ForgotPassword.path} element={<ForgotPassword />} />
    <Route path={Routes.Pricing.path} element={<Pricing />} />
    <Route path={Routes.AboutUs.path} element={<AboutUs />} />
    {/* <Route path={Routes.Partners.path} element={<Partner />} /> */}
    {/* <Route path={Routes.Onboarding.path} element={<Onboarding />} /> */}
    <Route path={Routes.ContactSales.path} element={ContactSales} />

    {/* Knowledge Bank */}
    <Route path={Routes.KnowledgeBank.path} element={<KnowledgeBank />} />
    <Route path={Routes.KnowledgeBankArticle.path} element={<KnowledgeBankArticle />} />

    {/* Legal */}
    <Route
      path={Routes.TermsAndConditions.path}
      element={<TermsAndConditions />}
    />
    <Route path={Routes.PrivacyPolicy.path} element={<PrivacyPolicy />} />

    <Route path="*" element={<NotFoundPage />} />
  </Switch>
);

// Export Main As Default
export default Main;
